<div class="stepper-icon" [class.completed]="completed">
    <img [src]="getSafeIconUrl()" [alt]="getIconAlt()" class="icon" [class.active]="active" />
</div>
